<template>
  <div class="container-outer" ref="outerElement">
    <div class="content" ref="scrollElement">
      <div class="container-inner" ref="innerElement">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const outerElement = ref<HTMLElement>();
const innerElement = ref<HTMLElement>();
const scrollElement = ref<HTMLElement>();

defineExpose({
  outerElement,
  innerElement,
  scrollElement,
});
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.container-outer {
  overflow: hidden;
  margin: calc(var(--t-spacing-lg) * -1);

  @include mobile {
    margin: calc(var(--t-spacing-md) * -1);
  }
}

.content {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.container-inner {
  width: max-content;
  min-width: 100%;
  padding: var(--t-spacing-lg);

  @include mobile {
    width: 100%;
    padding: var(--t-spacing-md);
  }
}
</style>
